// extracted by mini-css-extract-plugin
export default {"error":"LandingErrorMessage_error__AQbva","error-link":"LandingErrorMessage_error-link__M1H-B"};